import Axios from "axios";
import { ApiBaseUrl, DropdownUrl } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  IDropDownRequest,
  IDropDownResponse,
  IGetBranchesRequest,
  IGetEnumsRequest,
  IResponse,
} from "../models/dropdown.model";

export const GetEnums = (data: IGetEnumsRequest): Promise<IResponse[]> => {
  return Axios.post<ApiResultModel<IResponse[]>>(
    ApiBaseUrl + DropdownUrl + "/GetEnums",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetEnumsPersian = (
  data: IGetEnumsRequest
): Promise<IResponse[]> => {
  return Axios.post<ApiResultModel<IResponse[]>>(
    ApiBaseUrl + "/api/Enum" + "/GetEnumsPersian",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetBranches = (
  data: IGetBranchesRequest
): Promise<IResponse[]> => {
  return Axios.post<ApiResultModel<IResponse[]>>(
    ApiBaseUrl + DropdownUrl + "/GetBranches",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetBranchesAndStores = (
  data: IGetBranchesRequest
): Promise<IDropDownResponse[]> => {
  return Axios.post<ApiResultModel<IDropDownResponse[]>>(
    ApiBaseUrl + DropdownUrl + "/GetBranchesAndStores",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetIBans = (data: IGetBranchesRequest): Promise<IResponse[]> => {
  return Axios.post<ApiResultModel<IResponse[]>>(
    ApiBaseUrl + DropdownUrl + "/GetIBans",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetOrganizations = (
  data: IDropDownRequest
): Promise<IResponse[]> => {
  return Axios.post<ApiResultModel<IResponse[]>>(
    ApiBaseUrl + DropdownUrl + "/GetOrganizations",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetFinancialSuppliers = (
  data: IDropDownRequest
): Promise<IResponse[]> => {
  return Axios.post<ApiResultModel<IResponse[]>>(
    ApiBaseUrl + DropdownUrl + "/GetFinancialSuppliers",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const GetLoanTemplates = (
  data: IDropDownRequest
): Promise<IResponse[]> => {
  return Axios.post<ApiResultModel<IResponse[]>>(
    ApiBaseUrl + DropdownUrl + "/GetLoanTemplates",
    data
  ).then((result) => {
    return result.data.data;
  });
};
